import React, {useCallback, useEffect, useState} from "react";
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import "react-toastify/dist/ReactToastify.css";
import Button from "react-bootstrap/Button";
import RightModal from "./modalForm";

// hooks
import { useRedux, useHistory, useSearchInput } from "../../../hooks";

import {
    editDataSaleOrderStatus,
    getSaleOrderStatuses,
    onRemoveSaleOrderStatus,
    removeSaleOrderStatusModalHide,
    removeSaleOrderStatusModalShow,
    showRightModalSaleOrderStatus
} from "../../../redux/actions";

import TableList from "../../../components/TableList";
import SaleOrderStatusColumns from "./tableColumns";
import {SaleOrderStatusType} from "../../../redux/Sale/OrderStatus/types";
import {EntityActionsHandlersType} from "../../../redux/types";
import RemoveModal from "../../../components/RemoveForm";

import '../../../i18/config';
import {useTranslation} from "react-i18next";
import BreadCrumb from "../../../components/Common/BreadCrumb";
import Loader from "../../../components/Loader";
import MainListFilter from "../../../components/MainListFilter";

const SaleOrderStatusIndex = () => {
    const { dispatch, useAppSelector } = useRedux();

    const { t } = useTranslation(['common']);

    const componentType = 'saleOrderStatusTable';

    const {
        historyHash,
        searchPhrase,
        loadItems,
        handleSearchClick
    } = useHistory({
        componentType,
        loadAction: getSaleOrderStatuses,
        dispatch
    });

    const { onSearchInput } = useSearchInput(handleSearchClick);

    const {
        saleOrderStatus,
        isFetched
    } = useAppSelector(state => ({
        saleOrderStatus: state.SaleOrderStatus,
        isFetched: state.SaleOrderStatus.isFetched
    }));

    const openRightModal = useCallback((event:any) => {
        if ((event !== undefined) && (event.uuid !== undefined) && (event.uuid.length>0)){
            dispatch(editDataSaleOrderStatus({data:event, modalEditTitle: 'changeOrderStatus'}));
        } else {
            dispatch(showRightModalSaleOrderStatus({data:[], modalEditTitle: 'newOrderStatus'}));
        }
    },[dispatch]);

    const onEntityRemoveModalShow = useCallback((event:any) => {
        if ((event !== undefined) && (event.uuid !== undefined) && (event.uuid.length>0)){
            dispatch(removeSaleOrderStatusModalShow({data:event, modalEditTitle: 'deleteOrderStatus'}));
        }
    },[dispatch]);

    const onEntityRemoveModalHide = useCallback(() => dispatch(removeSaleOrderStatusModalHide()),[dispatch]);

    const onEntityRemove = useCallback((event:any) => {
        if ((event !== undefined) && (event.uuid !== undefined) && (event.uuid.length>0)){
            dispatch(onRemoveSaleOrderStatus({data:event, modalEditTitle: 'deleteOrderStatus'}));
        }
    },[dispatch]);

    useEffect(() => {
        if(saleOrderStatus.isNeedReload){
            loadItems();
        }
    }, [loadItems, saleOrderStatus.isNeedReload]);

    const EntityActionsHandlers:EntityActionsHandlersType = {
        onEdit: openRightModal,
        onRemove: onEntityRemoveModalShow
    }

    const onTableRowClick = useCallback((item:SaleOrderStatusType) => {
        if (item.actions && item.actions.canEdit){
            openRightModal(item);
        }
    },[openRightModal]);

    const columns = SaleOrderStatusColumns(EntityActionsHandlers);

    return (
        <>
            <BreadCrumb title={t('menu:orderStatuses')} pageTitle={t('menu:main')} />
                <Row className="g-4 mb-3">
                    <div className="col-sm-auto">
                        <div>
                            <Button variant="secondary" onClick={openRightModal} className="btn btn-success">
                                <i className="ri-add-line align-bottom me-1"/> {t('common:addNew')}
                            </Button>
                        </div>
                    </div>
                </Row>

                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardHeader className="border-bottom-0">
                                <h5 className="card-title mb-0">{t('menu:orderStatuses')}</h5>
                            </CardHeader>
                            <CardBody className="border border-dashed border-end-0 border-start-0 pb-3">
                                <MainListFilter
                                    onClick={handleSearchClick}
                                    value={searchPhrase}
                                    onChange={onSearchInput}
                                />
                            </CardBody>
                            <CardBody>
                                {isFetched ?
                                    <TableList
                                    columns={columns}
                                    data={saleOrderStatus.items}
                                    onRowClick={onTableRowClick}
                                    key={componentType}
                                    historyHash = {historyHash}
                                    paginationTotalRows={saleOrderStatus?.meta?.totalCount || 0}
                                    paginationServer={true}
                                    isShowChangePageSize={true}
                                    />
                                    :
                                    <Loader/>
                                }
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <RightModal/>
                <RemoveModal
                    onRemove={onEntityRemove}
                    handleClose={onEntityRemoveModalHide}
                    removeItem={saleOrderStatus.selectedItem}
                    isOpen={saleOrderStatus.removeModalShow}
                    modalTitle={saleOrderStatus.modalEditTitle}/>
        </>
    );
};

export default SaleOrderStatusIndex;


